import styles from './style.postcss';
import React, { Component } from 'react';
import classnames from 'classnames';
import { PageCard, Icon } from 'omni-common-ui';
import RcTooltip from 'rc-tooltip';
import RadialScoreDisplay from '../RadialScoreDisplay';
import ScoreBand from '../ScoreBand';
import ScoreStar from '../ScoreStar';
import PropTypes from 'prop-types';

const BENCHMARKING_DATA = [
  {
    range: '0-59%',
    category: 'Needs Improvement',
    descriptor:
      'Your child is finding it difficult to understand and use the language and skills taught in this unit. They need extra support to practise key vocabulary and structures and to build confidence in using what they have learned.',
  },
  {
    range: '60-79%',
    category: 'Developing',
    descriptor:
      'Your child is making progress with the language and skills from this unit and is beginning to use them with some success. They are close to meeting expectations but may still need support or reminders to use new vocabulary and structures accurately and consistently.',
  },
  {
    range: '80-89%',
    category: 'On Track',
    descriptor:
      'Your child shows a good understanding of the language and skills taught in this unit and meets the expected learning goals. They can use the key vocabulary and structures independently in familiar activities, with only occasional mistakes.',
  },
  {
    range: '90-100%',
    category: 'Outstanding',
    descriptor:
      'Your child shows an excellent understanding of the language and skills taught in this unit and uses what they have learned confidently and accurately. They apply the unit\'s vocabulary and structures effectively in a range of activities and may use them flexibly or make clear connections with other learning.',
  },
];

export class ProgressTestCard extends Component {
  constructor(props) {
    super(props);
    this.state = { benchmarkingTooltipVisible: false };
  }

  render() {
    const { publishedDateStr, name, percentage, isSSCourseTypeGroup, className } = this.props;
    return <PageCard className={classnames(className, styles.ProgressTestCard)}>
      <PageCard.Heading text="Progress" />
      <PageCard.Content>
        <div className={styles.ProgressTestCard_wrapper}>
          {isSSCourseTypeGroup ?
            <ScoreStar currentResult={percentage}
                fullMark={100} /> :
            <RadialScoreDisplay className={styles.ProgressTestCard_wrapper_radialScore}
                radius={40}
                circleStrokeWidth={5}
                edgeSize={120}
                forcedTextY={66}
                unit="percent"
                displayText
                formatText={(value) => `${value}%`}
                circleStroke="#e0e0e0"
                progressStroke="#74d17f"
                value={percentage} />}
          <div className={styles.ProgressTestCard_wrapper_bandInfo}>
            <h2 className={styles.ProgressTestCard_wrapper_bandInfo_title}>
              Total Score
            </h2>
            <div className={styles.ProgressTestCard_wrapper_bandInfo_nameRow}>
              <ScoreBand score={percentage} textKey="name"
                  className={styles.ProgressTestCard_wrapper_bandInfo_name} />
              <RcTooltip
                  placement="right"
                  trigger={['hover']}
                  destroyPopupOnHide
                  visible={this.state.benchmarkingTooltipVisible}
                  onVisibleChange={(visible) =>
                    this.setState({ benchmarkingTooltipVisible: visible })
                  }
                  overlayClassName={styles.BenchmarkingTooltip_overlay}
                  overlay={
                    <div className={styles.BenchmarkingTooltip}>
                      <div className={styles.BenchmarkingTooltip_title}>
                        Benchmarking
                      </div>
                      {BENCHMARKING_DATA.map((item, index) => (
                        <div key={index} className={styles.BenchmarkingTooltip_row}>
                          <div className={styles.BenchmarkingTooltip_range}>
                            {item.range}
                          </div>
                          <div className={styles.BenchmarkingTooltip_content}>
                            <div className={styles.BenchmarkingTooltip_category}>
                              {item.category}
                            </div>
                            <div className={styles.BenchmarkingTooltip_descriptor}>
                              {item.descriptor}
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className={styles.BenchmarkingTooltip_footer}>
                        <span
                            className={styles.BenchmarkingTooltip_gotIt}
                            onClick={() =>
                              this.setState({ benchmarkingTooltipVisible: false })
                            }>
                          Got it
                        </span>
                      </div>
                    </div>
                  }>
                <div className={styles.ProgressTestCard_wrapper_bandInfo_icon}>
                  <Icon id="info" />
                </div>
              </RcTooltip>
            </div>
          </div>
          <div className={styles.ProgressTestCard_wrapper_divider} />
          <ScoreBand score={percentage}
              className={styles.ProgressTestCard_wrapper_interpretation} />
        </div>
      </PageCard.Content>
    </PageCard>;
  }
}

ProgressTestCard.propTypes = {
  className: PropTypes.object,
  publishedDateStr: PropTypes.string,
  name: PropTypes.string,
  percentage: PropTypes.number,
  isSSCourseTypeGroup: PropTypes.bool.isRequired,
};

export default ProgressTestCard;



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/ProgressTestCard/index.jsx